import { useMemo, useState } from 'react'

import { LangkahObservasiCard } from '../../LangkahObservasiCard'
import { PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS } from 'app/KinerjaShared/constants/pelaksanaanSteps'
import { DialogPelaksanaanAppealRollback } from 'app/KinerjaPage/pages/PelaksanaanV2/components/DialogPelaksanaanAppeal/DialogPelaksanaanAppealRollback'
import { DialogPelaksanaanAppealRequest } from 'app/KinerjaPage/pages/PelaksanaanV2/components/DialogPelaksanaanAppeal/DialogPelaksanaanAppealRequest'
import { DialogPelaksanaanAppealConfirmation } from 'app/KinerjaPage/pages/PelaksanaanV2/components/DialogPelaksanaanAppeal/DialogPelaksanaanAppealConfirmation'

import type { LangkahObservasiCardProps } from '../../LangkahObservasiCard'

export const LangkahDokumenPersiapanCard = (
  props: LangkahObservasiCardProps
) => {
  const CURRENT_STEP = 'DOCUMENT_PREPARATION'
  const currentStateOrder =
    PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[props?.state]?.order ?? -1
  const stateOrder = PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[CURRENT_STEP].order

  const stepDeficit =
    currentStateOrder -
    PENGELOLAAN_KINERJA_PELAKSANAAN_STEPS[CURRENT_STEP].order
  const [activeDialog, setActiveDialog] = useState<
    'CONFIRMATION' | 'ROLLBACK' | 'APPEAL' | 'NONE'
  >('NONE')

  const handleClickEdit = () => {
    if (stepDeficit === 1 && props.latestFormState === 'NOT_CREATED')
      return setActiveDialog('ROLLBACK')
    return setActiveDialog('CONFIRMATION')
  }

  const overrideState = useMemo(() => {
    if (currentStateOrder > stateOrder) return 'done'
    if (currentStateOrder === stateOrder) {
      switch (props.latestFormState) {
        case 'SUBMITTED':
          return 'done'
        case 'DRAFT':
          return props.appealState ? 'locked' : 'draft'
        case 'NOT_CREATED':
          return props.appealState ? 'locked' : 'unlocked'
      }
    }
    return 'unlocked'
  }, [currentStateOrder, props, stateOrder])

  return (
    <>
      <LangkahObservasiCard
        {...props}
        onClickEdit={handleClickEdit}
        currentForm={CURRENT_STEP}
        overrideState={overrideState}
        isAppealed={props.appealState === CURRENT_STEP}
      />
      <DialogPelaksanaanAppealRollback
        isOpen={activeDialog === 'ROLLBACK'}
        onClose={() => setActiveDialog('NONE')}
        onCancel={() => setActiveDialog('NONE')}
        step={CURRENT_STEP}
        url={`${props.url}`}
      />
      <DialogPelaksanaanAppealConfirmation
        isOpen={activeDialog === 'CONFIRMATION'}
        onClose={() => setActiveDialog('NONE')}
        onCancel={() => setActiveDialog('NONE')}
        onConfirm={() => setActiveDialog('APPEAL')}
      />
      <DialogPelaksanaanAppealRequest
        isOpen={activeDialog === 'APPEAL'}
        step={CURRENT_STEP}
        onClose={() => setActiveDialog('NONE')}
        headerText="Jika lanjut ubah, isi seluruh dokumen ini akan dihapus:"
        subHeaderText="Semua dokumen yang Anda dan atasan sudah isi akan dihapus."
        infoText="Anda harus mengajukan perubahan ke atasan. Mohon ketik kalimat ini pada kolom kalimat persetujuan:"
        confirmationText="Saya setuju bahwa isi seluruh dokumen akan dihapus dan saya harus mengulang observasi dari awal."
        initialDialogSize="lg"
        stepDeficit={stepDeficit}
        needWrittenConfirmation
      />
    </>
  )
}
